
    <template>
        <component :productId='id' ref="mainProPage" :is="currentComponent" v-on:getBack="showDetailPage1"></component>
    </template>


  
  <script>
  import Product from '../../components/product/Product';
  import ProductDetail from '../../components/product/ProductDetail';
  
  export default {
    data() {
      return {
        id:'',
        currentComponent : Product,
      };
    },
    mounted() {
        this.currentComponent = Product;
    },
    methods: {
      addToCart(product) {
        // 处理添加到购物车的逻辑
        console.log('商品已添加到购物车:', product);
      },
      showDetailPage1(id){
        console.log('tiaozhuan'+id);
        if(id==='back'){
            this.currentComponent = Product;
        } else{
            this.id = id;
            this.currentComponent = ProductDetail;
        }
      }
    },
    components:{Product}
  };
  </script>